import { Pipe, PipeTransform } from '@angular/core';

interface BlogPostData {
  tags: string[];
  title: string;
  excerptLength: number;
}

const removeHTMLMarkdownTags = /(<.*?>)|[!\[](.*\)?)\)/gim;

@Pipe({
  name: 'blogPostExcerpt'
})
export class BlogPostExcerptPipe implements PipeTransform {
  transform(value: string, blogPostData: BlogPostData): string {
    const minTitleLength = 26;
    const maxTitleLength = 34;
    const minPostNewLinesLength = 0;
    const maxPostNewLinesLength = 15;
    const titleLength = blogPostData?.title?.length || 0;
    const tagsLength = blogPostData?.tags?.join(', ').length || 0;
    const excerptLength = blogPostData?.excerptLength || 0;
    const postNewLinesLength = value.match(/(\n)+/g)?.length || 0;

    const postLength =
      excerptLength -
      (this.getTextLength(titleLength, minTitleLength, maxTitleLength) +
        tagsLength +
        this.getTextLength(postNewLinesLength, minPostNewLinesLength, maxPostNewLinesLength));

    return `${value
      ?.replace(removeHTMLMarkdownTags, '')
      .substring(0, postLength)}...`;
  }

  private getTextLength(length: number, minLength: number, maxLength: number) {
    if (length > maxLength) {
      return maxLength;
    }
    if (length < minLength) {
      return minLength;
    }
    return length;
  }
}
